<lib-filter-list #productExportList [configService]="productExportListConfigService"></lib-filter-list>
